<form class="ui form" [formGroup]="newsletterForm" (ngSubmit)="onSubmit()">
  @if (!simple) {
    <!--EMAIL-->
    <div class="field" [class.required]="!admin" [class.error]="newsletterForm.get('email')?.invalid">
      <label for="email" i18n="@@newsletter-form-mail">Email für den Newsletter:</label>
      <input formControlName="email" type="text" name="email" placeholder="example@uni-beispiel.de" id="email" i18n-placeholder="@@email-placeholder">
      @if (newsletterForm?.controls?.email?.hasError('email')) {
        <div class="ui pointing red basic label" i18n="@@email-invalid">
          Die Mailadresse ist nicht gültig!
        </div>
      } @else if (newsletterForm?.controls?.email?.hasError('forbiddenDomain')) {
        <div class="ui pointing red basic label" i18n="@@email-forbidden-domain">
          Die Mailadresse hat keine passende Domain von der Institution {{ editUser.institution?.name }}.
        </div>
      }
    </div>
  }
  <!--LOCALE-->
  <div class="field" [class.required]="!admin" [class.error]="newsletterForm.get('locale')?.invalid">
    <label for="locale" i18n="@@newsletter-form-locale">Sprache für den Newsletter:</label>
    <sui-select formControlName="locale" id="locale" class="selection" [options]="LOCALES" labelField="label" valueField="id">
      @for (locale of LOCALES; track locale.id) {
        <sui-select-option [value]="locale"></sui-select-option>
      }
    </sui-select>
    @if (newsletterForm.controls.locale.value === 'en') {
      <div class="ui pointing orange basic label" i18n="@@newsletter-form-locale-en-warning">
        Die Inhalte der Artikel im Newsletter werden von Autoren eingestellt und sind nicht immer auf Englisch verfügbar.
        In diesem Fall wird die deutsche Version des Artikels angezeigt.
      </div>
    }
  </div>
  <!--TOPICS-->
  <div class="field" [class.required]="!admin" [class.error]="newsletterForm.get('topics')?.invalid">
    <label for="topics" i18n="@@newsletter-form-topics">
      Ich möchte Informationen zu folgenden Kategorien erhalten (Eine Mehrfachauswahl ist möglich!):
    </label>
    <sui-multi-select
      #topicsMultiSelect
      class="selection"
      id="topics"
      formControlName="topics"
      [options]="topics"
      [labelField]="$localize.locale === 'en' ? 'englishName' : 'name'"
      valueField="_id"
    >
      @for (kind of TOPIC_KINDS; track kind) {
        <div class="header">
          <i class="list icon"></i>
          {{ kind.name }}
        </div>
        <div class="divider"></div>
        @for (option of topicsMultiSelect.filteredOptions; track option._id) {
          @if (option.kind === kind.kind) {
            <sui-select-option [value]="option"></sui-select-option>
          }
        }
      }
    </sui-multi-select>
  </div>
  <!--SUBJECTAREAS-->
  <div class="field" [class.required]="!admin" [class.error]="newsletterForm.get('subjectAreas')?.invalid">
    <label for="subjectAreas" i18n="@@newsletter-form-subject-areas">
      Ich möchte aus den Kategorien nur Artikel zu folgenden Fachrichtungen erhalten
      (Eine Mehrfachauswahl ist möglich!):
    </label>
    <sui-multi-select
      #subjectAreasMultiSelect
      class="selection"
      id="subjectAreas"
      formControlName="subjectAreas"
      [options]="subjectAreas"
      [labelField]="$localize.locale === 'en' ? 'englishName' : 'name'"
      valueField="_id"
    >
      @for (option of subjectAreasMultiSelect.filteredOptions; track option._id) {
        <sui-select-option [value]="option"></sui-select-option>
      }
    </sui-multi-select>
  </div>
  <!--WEEKDAYS FOR MAILING-->
  <div class="field" [class.required]="!admin"  [class.error]="newsletterForm.get('days')?.invalid">
    <label for="weekdays" i18n="@@newsletter-form-weekdays">
      An folgenden Wochentagen möchte ich den Newsletter erhalten (Eine Mehrfachauswahl ist möglich!):
    </label>
    <sui-multi-select
      #daysMultiSelect
      class="selection"
      id="weekdays"
      formControlName="days"
      [options]="WEEKDAYS"
      labelField="name"
      valueField="value"
    >
      @for (option of daysMultiSelect.filteredOptions; track option) {
        <sui-select-option [value]="option"></sui-select-option>
      }
    </sui-multi-select>
  </div>
  <!--RECEIVE ALL ARTICLES FOR INST-->
  <div class="field">
    <label for="receiveInstitutionArticles" i18n="@@newsletter-form-institution-articles">
      Ich möchte zusätzlich alle Artikel für meine Institution erhalten
      (unabhängig von gewählten Kategorien und Fachrichtungen!)
    </label>
    <sui-checkbox id="receiveInstitutionArticles" class="toggle" formControlName="receiveInstitutionArticles"></sui-checkbox>
  </div>
  <!--INTERNAL MESSAGES-->
  <div class="field">
    <label for="receiveInternalMessages" i18n="@@newsletter-form-internal-messages">
      Ich möchte interne Mitteilungen meiner Institution erhalten
    </label>
    <sui-checkbox id="receiveInternalMessages" class="toggle" formControlName="receiveInternalMessages"></sui-checkbox>
  </div>
</form>
